import labels from '../../api/labels';

export default (state = labels.id.emptyResponse, action) => {
	switch (action.type) {
		case 'LABELS_ID_DATA':
			return action.data;
		default:
			return state;
	}
};

export const action = {
	data: data => ({ type: 'LABELS_ID_DATA', data }),
};
